import React from "react";
import { MdOutlineDirectionsCar } from "react-icons/md";

const SearchStopped = ({ onClose }) => {
  return (
    <div className="fixed bottom-0 left-0 w-full bg-gray-50 dark:bg-gray-900 shadow-lg rounded-t-lg p-6 z-50">

      <div className="flex items-center justify-between mb-4">
        <p className="text-sm md:text-base text-gray-600 dark:text-gray-300 max-w-[80%]">
          There are no drivers online at this moment for your preferences. Please retry later.
        </p>
        <MdOutlineDirectionsCar className="text-gray-500 dark:text-gray-400 text-4xl" />
      </div>

      <div className="w-full flex justify-center">
        <button
          onClick={onClose}
          className="bg-red-500 hover:bg-red-700 text-white font-medium py-2 px-6 rounded transition"
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default SearchStopped;
